var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13.0946V14.8688C20 17.1959 20 18.3594 19.6816 19.2974C19.082 21.0638 17.695 22.4508 15.9286 23.0504C14.9906 23.3688 13.8271 23.3688 11.5 23.3688C9.17293 23.3688 8.0094 23.3688 7.07137 23.0504C5.30502 22.4508 3.91801 21.0638 3.31842 19.2974C3 18.3594 3 17.1959 3 14.8688V9.32129C3 6.99422 3 5.83069 3.31842 4.89265C3.91801 3.12631 5.30502 1.7393 7.07137 1.13971C8.0094 0.821289 9.17293 0.821289 11.5 0.821289C13.8271 0.821289 14.9906 0.821289 15.9286 1.13971C17.695 1.7393 19.082 3.12631 19.6816 4.89265C20 5.83069 20 6.99422 20 9.32128V11.0946H12.6114L15.8686 7.65814L14.4171 6.28229L9.55992 11.4067L8.90788 12.0946L9.55992 12.7826L14.4171 17.907L15.8686 16.5312L12.6114 13.0946H20Z",
    fill: "#382E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.022d7db4f08b8663b51db4cc55e9aadc.svg";
export { ForwardRef as ReactComponent };